<template>
  <el-menu class="navbar" mode="horizontal">
    <div class="user-profile-container" trigger="click">
      <div class="user-profile-content">
        <div class="menu-icons">
          <span class="menu-icon" @click="skipNotice">
            <template v-if="newNotify===0">
              <i class="el-icon-message icon" />
            </template>
            <template v-else>
              <el-badge :value="newNotify" :max="99" class="item">
                <i class="el-icon-message icon" />
              </el-badge>
            </template>
          </span>
        </div>
        <el-dropdown>
          <div class="user-profile-body">
            <img
              class="user-avatar"
              :src="require('@/assets/head.png')"
            />
            <span class="user-name">{{getUserName}}</span>
          </div>
          <el-dropdown-menu slot="dropdown" class="user-dropdown">
            <router-link to="/common/userCenter">
              <el-dropdown-item>个人设置</el-dropdown-item>
            </router-link>
            <el-dropdown-item>
              <span style="display:block;" @click="logout">退出</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </el-menu>
</template>

<script>
import { storageUtil } from "@/utils";
import { mapGetters } from "vuex";
import { notifyRes, userRes } from "@/api";
import { setInterval, clearInterval } from "timers";
let v1;
export default {
  name: "NavBar",
  data() {
    return {
      newNotify: 0
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
    getUserName() {
      return this.userInfo.fullName;
    }
  },
  mounted() {
    // 启动轮询查询最新消息
    this.getNotify();
  },
  methods: {
    logout() {
      userRes.logout().then(res => {
        storageUtil.removeAll();
        this.$router.push("/login");
        location.reload()
      });
    },
    skipNotice() {
      this.newNotify = 0;
      this.$router.push("/common/notice");
    },
    // 获取最新的通知
    getNotify() {
      const req = {
        isRead: 0
      };
      v1 = setInterval(() => {
        notifyRes.getList(req).then(res => {
          this.newNotify = res.length;
        });
      }, 500000);
    }
  },
  beforeDestroy() {
    clearInterval(v1);
  }
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 64px;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  .user-profile-container {
    position: absolute;
    right: 20px;
    cursor: pointer;
    .user-profile-content {
      display: flex;
      padding: 20px 0;
      float: left;
    }
    .menu-icons {
      display: flex;
      align-items: center;
      float: left;
      .menu-icon {
        padding: 0 12px;
        .icon {
          display: inline-block;
          font-size: 18px;
          text-align: center;
        }
      }
    }
    .el-dropdown{
      float:left // 兼容IE9，外布局flex,内布局浮动
    }
    .user-profile-body {
      position: relative;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      text-align: center;
      padding-right: 14px;
    }
    .user-profile-body img{
      float: left
    }
    .user-avatar {
      width: 24px;
      height: 24px;
      margin: 0 8px 0 12px;
      border-radius: 4px;
    }
    .user-name {
      color: rgba(0, 0, 0, 0.65);
    }
    .user-department {
      font-size: 12px;
      color: rgba(102, 102, 102, 0.65);
    }
    .el-icon-caret-bottom {
      position: absolute;
      right: 0;
      top: 13px;
      font-size: 12px;
    }
  }
}
</style>

